import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBolt = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M7.03317 12.1333L10.4832 8.00001H7.8165L8.29984 4.21668L5.2165 8.66668H7.53317L7.03317 12.1333ZM5.33317 14.6667L5.99984 10H2.6665L8.6665 1.33334H9.99984L9.33317 6.66668H13.3332L6.6665 14.6667H5.33317Z",
		fill: "#E30613"
	})]
});
const ForwardRef = forwardRef(SvgBolt);
export { ForwardRef as ReactComponent };
